import {ENUMS_URL} from '../../utils/helpers/api.routes';
import {requests} from '../../utils/helpers/api.services';
import {IEnums} from '../../model/shared/IEnums';

export const EnumService = {
    getEnums: (): Promise<IEnums> => requests.get(ENUMS_URL),
}